// extracted by mini-css-extract-plugin
export default {"button":"Tests-module__button__+Wmco"};